var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{class:{
      'card mc-liveview clearfix': _vm.$store.state.sidebar.sideBarOpen === true,
      'card mc-liveview clearfix close-sidebar': _vm.$store.state.sidebar.sideBarOpen === false,
    }},[_c('VideoList'),_c('SideBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }